module.exports = __webpack_public_path__ + "static/img/tutorial-tool-attraction-2.9ba99b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-tool-attraction-2.jpg
// module id = qPRf
// module chunks = 3